import { createSlice } from "@reduxjs/toolkit";
import { getJobPosts } from "./thunk";

export interface IState {
  jobPosts: any;
  isJobPostLoading: boolean;
  isJobPostSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  jobPosts: null,
  isJobPostLoading: false,
  isJobPostSuccess: false,

  error: {},
};

const JobPostSlice = createSlice({
  name: "JobPost",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getJobPosts
    builder.addCase(getJobPosts.pending, (state: IState, action: any) => {
      state.isJobPostLoading = true;
    });
    builder.addCase(getJobPosts.fulfilled, (state: IState, action: any) => {
      state.jobPosts = action.payload.data;
      state.isJobPostSuccess = true;
      state.isJobPostLoading = false;
    });
    builder.addCase(getJobPosts.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isJobPostSuccess = false;
      state.isJobPostLoading = false;
    });

  },
});

export default JobPostSlice.reducer;